function quoteComplete(quote) {
    // Adobe Omniture Analytics Code for Quote Retrieval
    try {
        _satellite.track('iffco-get-quote', {
            quoteId: quote.quoteId,
            product: quote.contractType,
            vehicleRegno: quote.registrationNo,
            policyType: quote.policyType,
            mobileNo: quote.policyProfile.maskMobile,
            emailId: quote.policyProfile.maskEmail
        });
    } catch (error) {
        console.error('quoteComplete Adobe Omniture Error', error);
    }
    // Google Tag Manager Code
    try {
        window['dataLayer'] = window['dataLayer'] || [];
        // window['dataLayer'].push({ 'event': 'get_quote' });
        window.dataLayer.push({
            event: 'GetQuote_MotorInsurance',
            dimension1: quote.quoteId, // LeadID
            dimension5: quote.contractType, // Private Car / Two Wheeler
            dimension6: quote.registrationNo, // Vehicle Registration No
            dimension7: quote.policyProfile.maskMobile, // Mobile No
            dimension8: quote.policyProfile.maskEmail, // Email ID
            dimension9: quote.quoteId // Quote ID
        });
    } catch (error) {
        console.error('quoteComplete GTM Error', error);
    }
}

function healthQuoteComplete(quote) {
    // Adobe Omniture Analytics Code for Quote Retrieval
    try {
        _satellite.track('iffco-get-quote', {
            quoteId: quote.quoteId,
            product: quote.contractType,
            vehicleRegno: '',
            policyType: quote.insuranceType,
            mobileNo: quote.policyProfile.maskMobile,
            emailId: quote.policyProfile.maskEmail
        });
    } catch (error) {
        console.error('healthQuoteComplete Adobe Omniture Error', error);
    }
    // Google Tag Manager Code
    try {
        window['dataLayer'] = window['dataLayer'] || [];
        // window['dataLayer'].push({ 'event': 'get_quote' });
        window['dataLayer'].push({
            event: 'GetQuote_HealthInsurance',
            dimension1: quote.quoteId, // LeadID
            dimension5: quote.contractType, // Health	
            dimension7: quote.policyProfile.maskMobile, // Mobile No
            dimension8: quote.policyProfile.maskEmail, // Email ID
            dimension9: quote.quoteId // Quote ID
        });
    } catch (error) {
        console.error('healthQuoteComplete GTM Error', error);
    }
}

function allInOneHomeQuoteComplete(quote) {
    // Adobe Omniture Analytics Code for Quote Retrieval
    try {
        _satellite.track('iffco-get-quote', {
            quoteId: quote.quoteId,
            product: quote.contractType,
            vehicleRegno: '',
            policyType: quote.insuranceType,
            mobileNo: quote.policyProfile.maskMobile,
            emailId: quote.policyProfile.maskEmail
        });
    } catch (error) {
        console.error('allInOneHomeQuoteComplete Adobe Omniture Error', error);
    }
    // Google Tag Manager Code
    try {
        window['dataLayer'] = window['dataLayer'] || [];
        // window['dataLayer'].push({ 'event': 'get_quote' });
        window['dataLayer'].push({
            event: 'GetQuote_HomeInsurance',
            dimension1: quote.quoteId, // LeadID
            dimension5: quote.contractType, // AHP	
            dimension7: quote.policyProfile.maskMobile, // Mobile No
            dimension8: quote.policyProfile.maskEmail, // Email ID
            dimension9: quote.quoteId // Quote ID
        });
    } catch (error) {
        console.error('allInOneHomeQuoteComplete GTM Error', error);
    }
}

function transactionComplete(paymentRes) {
    // Adobe Omniture Analytics Code for Transaction Complete
    try {
        _satellite.track('iffco-purchase-complete', {
            orderId: paymentRes.orderNumber,
            traceNumber: paymentRes.traceNumber,
            amount: paymentRes.amount,
            emailId: paymentRes.maskEmail,
            mobileNo: paymentRes.maskMobile,
            vehicleRegNo: paymentRes.regNumber,
            policyType: paymentRes.contractType,
            contractType: paymentRes.contractType,
            product: paymentRes.contractType,
            insuranceType: paymentRes.insuranceType,
            policyNo: paymentRes.policyNumber,
            QuoteId: paymentRes.policyQuoteId,
            branchCode: paymentRes.agentNumber,
            couponCode: paymentRes.corporateDiscountCode
        });
    } catch (error) {
        console.error('transactionComplete Adobe Omniture Error', error);
    }
    // Google Tag Manager Code
    try {
        // tslint:disable-next-line: no-string-literal
        window['dataLayer'] = window['dataLayer'] || [];
        // tslint:disable-next-line: no-string-literal
        window['dataLayer'].push({
            event: 'transaction_complete',
            transactionId: paymentRes.orderNumber, // Transaction ID
            transactionTotal: paymentRes.amount, // Transaction Amount
            dimension1: paymentRes.policyQuoteId, // LeadID
            dimension5: paymentRes.contractType, // Product
            dimension6: paymentRes.regNumber, // Vehicle Registration No
            dimension7: paymentRes.maskMobile, // Mobile No
            dimension8: paymentRes.maskEmail, // Email ID
            dimension9: paymentRes.policyQuoteId, // Quote ID
            dimension10: paymentRes.agentNumber, // Branch ID
            dimension11: paymentRes.policyNumber, // Policy No
            dimension13: paymentRes.corporateDiscountCode, // Coupon Code
            transactionProducts: [{
                sku: paymentRes.contractType, // SKU ID for products
                name: paymentRes.contractType, // TWP / PCP / IHP / FHP 
                category: paymentRes.insuranceType, // New / Renewal
                price: paymentRes.amount,
                quantity: 1
            }]
        });
    } catch (error) {
        console.error('transactionComplete GTM Error', error);
    }
    // Facebook Pixel Code
    try {
        fbq('track', 'Purchase', {
            value: paymentRes.amount,
            currency: 'INR'
        });
    } catch (error) {
        console.error('transactionComplete FB Error', error);
    }

}
export { transactionComplete, quoteComplete, healthQuoteComplete, allInOneHomeQuoteComplete }
